import { Component, Input, OnInit } from '@angular/core';
import { PageTitleService } from '../../core/page-title/page-title.service';
import { ChkService } from '../../service/chk.service';
import { ApiService } from 'app/service/api.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import * as matriz_evaluacion from '../../../assets/formularios/matriz-evaluacion.json';
import { combineLatest } from 'rxjs';

import Swal from 'sweetalert2';


@Component({
  selector: 'modal-calificacion',
  templateUrl: './modal-calificacion.component.html',
  styleUrls: ['./modal-calificacion.component.scss']
})
export class ModalCalificacionComponent implements OnInit {

	@Input() cmomentario : Number = 0;

	numberCharactersLeft = 0;
	evaluacionFinalizada = false;
	Admin = false;
	comentario = null ;

	formulario: any = JSON.parse(JSON.stringify(matriz_evaluacion));

	calificacionTotal =0;
  
  
	datosUsuarios : any;
  
	form: any;
	formid: any;
	private solicitudEvaluacion = 0;

	constructor(
		private service:ChkService, 
		private pageTitleService:PageTitleService,
		private api: ApiService,
		private toastr: ToastrService,
		private route: ActivatedRoute,
		private router: Router

	) { }

	
	ngOnInit(): void {
		combineLatest([this.route.paramMap, this.route.queryParamMap]).subscribe(([params, queryParams]) => {
			this.form = params.get('form') || queryParams.get('form');
			this.formid = params.get('id') || queryParams.get('id');
			this.Admin = !!this.formid;

			// No reutilizar respuestas de la evaluación anterior si Angular conserva
			// este componente al navegar entre evaluadores o postulaciones.
			this.formulario = JSON.parse(JSON.stringify(matriz_evaluacion));
			this.datosUsuarios = null;
			this.comentario = null;
			this.numberCharactersLeft = 200;
			this.calificacionTotal = 0;
			this.evaluacionFinalizada = false;

			if (this.form) {
				this.reloadDataByid(this.form, this.formid);
			}
		});
	  }
	
	  reloadDataByid(id, _id = null){
		const solicitud = ++this.solicitudEvaluacion;
		this.api.getEvalByid({id: id, _id: _id}).subscribe(
		  response => {
			if (solicitud !== this.solicitudEvaluacion) {
				return;
			}
	
			if(!Array.isArray(response) || response.length == 0){
			  this.datosUsuarios = null;
			} else {
			  this.datosUsuarios = response[0];
			  this.parseData();
			}
	
	
		  },
		  error => alert(error)
		);
	  }
	
	
	async  parseData(){
		// console.log(this.formulario1.formulario)

		this.comentario = this.datosUsuarios['comentario-gen']
		if(this.comentario){
			this.numberCharactersLeft = (200 - this.comentario.length < 0)? 0: 200 - this.comentario.length
		}else {
			this.numberCharactersLeft = 200
		}
		this.evaluacionFinalizada = this.datosUsuarios.evaluacionFinalizada;
		this.evaluacionFinalizada = false;

	
		let aux = await this.formulario.formulario.map(form=>{
		  console.log('///////////form///////////',form)
		//   form['comentarios'] = 'asdfsdaf'
		if(this.datosUsuarios[form.parameter + '-' + form.parameter]){
	
			form['comentarios'] = this.datosUsuarios[form.parameter + '-' + form.parameter];
			}

		  // console.log(form.parametros)
		  form.evaluaciones.map(item=>{
	
			console.log(this.datosUsuarios[form.parameter + '-' + item.parameter+ '-S'])
	
			const valorGuardado = this.datosUsuarios[form.parameter + '-' + item.parameter + '-S'];
			if (valorGuardado !== undefined && valorGuardado !== null && valorGuardado !== '') {
				const opcionGuardada = item.opciones.find(opcion => String(opcion.id) === String(valorGuardado));
				item.value = opcionGuardada ? opcionGuardada.id : valorGuardado;
			}

			const calificacionGuardada = this.datosUsuarios[form.parameter + '-' + item.parameter + '-C'];
			if (calificacionGuardada !== undefined && calificacionGuardada !== null && calificacionGuardada !== '') {
				item.calificacion = Number(calificacionGuardada);
			}
			// if(this.datosUsuarios[form.parameter + '-' + item.parameter]){
	
			// 	item['comentarios'] = this.datosUsuarios[form.parameter + '-' + item.parameter];
			// }
			

			// if(item.value){
			  // console.log(item.value)
			// } else {
			 
			// }
	
			// (item.value)? null: this.datosCompletos = false;
	
	
			return item
		  })
	
		  let sumatoria = 0;
		  console.log('evaluaciones', form.evaluaciones)
	
		  for(let i=0; i<form.evaluaciones.length ; i++){
			console.log('calificacion', form.evaluaciones[i].calificacion)
			if(form.evaluaciones[i].type == 'full'){
				sumatoria = sumatoria + Number(form.evaluaciones[i].calificacion);

			} else if(form.evaluaciones[i].type == 'ponderacion'){
				sumatoria = sumatoria + Number(form.evaluaciones[i].calificacion) * Number((form.evaluaciones[i] as any).factor)/10;
			} else {  // 'medio'
				sumatoria = sumatoria + Number(form.evaluaciones[i].calificacion)/2;
			}
			
		  }

		  if(form.type =='suma'){
			form.calificacion = sumatoria;
		  } else { // promedio
			form.calificacion = sumatoria/form.evaluaciones.length;
		  }

	
		//   form.calificacion = sumatoria/form.evaluaciones.length;


		 


	
		  if(isNaN(form.calificacion)){
			form.calificacion = 0;
		  }
	
	
		})
	
		console.log(aux)
		console.log('formulario',this.formulario)
		this.obtenerCalificacionGeneral(false)
	
	  }
	
	
	  
	
	  
	  // reloadData(){
	  //   this.api.getListUsers({tipo: 'usuario'}).subscribe(
	  //     response => {
	  //       console.log(response);
	
	  //       if(response.length ==0){
	  //         this.datosUsuarios = [];
	  //       } else {
	  //         this.datosUsuarios = response;
	  //         console.log(this.datosUsuarios)
	  //         // this.parseCategoria();
	  //       }
	
	
	  //     },
	  //     error => alert(error)
	  //   );
	  // }
	
	
	  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	  
	
	  updateValueForm(event, parameter, subgrupo, objeto) {
	
	
		console.log(event);
		console.log(event.id);
		console.log('parameter', parameter);
	
		console.log('subgrupo', subgrupo);
		console.log('objeto', objeto);
		console.log('formulario',this.formulario);
	
	
		let body: any = {
		  id: this.form,
		  "parameter": subgrupo + '-'+ parameter,
		  "value": event.id,
		}

		if(this.Admin){
			body._id = this.formid
		}
	
		console.log(body)
	
		this.api.updateEval(body).subscribe(
		  response => {
			console.log(response);
			this.toastr.success('Actualización correcta');
	
	
		  },
		  error => alert(error)
		);
	
	
	  }
	

	  commentChangedForm(event, parameter) {
		console.log(event.target.name);
		console.log(event.target.value);
		console.log('parameter', parameter);
	
		console.log('formulario',this.formulario);
	
	
	
	
		let body : any = {
		  id: this.form,
		  "parameter":  parameter,
		  "value": event.target.value
		}

		if(this.Admin){
			body._id = this.formid
		}
	
		console.log(body)
		this.api.updateEval(body).subscribe(
		  response => {
			console.log(response);
			this.toastr.success('Actualización correcta');
	
	
		  },
		  error => alert(error)
		);
	  }
	
	  
	  paramChangedForm(event, parameter, subgrupo, objeto, item) {
		console.log(event.target.name);
		console.log(event.target.value);
		console.log('parameter', parameter);
	
		console.log('subgrupo', subgrupo);
		console.log('objeto', objeto);
		console.log('formulario',this.formulario);
	
	
		if(event.target.name == 'calificacion' ){
	
		  let sumatoria = 0;
		  console.log('evaluaciones', item.evaluaciones)
	
		  for(let i=0; i<item.evaluaciones.length ; i++){
			console.log('calificacion', item.evaluaciones[i].calificacion)
			if(item.evaluaciones[i].type == 'full'){
				sumatoria = sumatoria + Number(item.evaluaciones[i].calificacion);

			} else if(item.evaluaciones[i].type == 'ponderacion'){
				sumatoria = sumatoria + Number(item.evaluaciones[i].calificacion) * Number((item.evaluaciones[i] as any).factor)/10;
			} else {  // 'medio'
				sumatoria = sumatoria + Number(item.evaluaciones[i].calificacion)/2;
			}
		  }

		  if(item.type =='suma'){
			item.calificacion = sumatoria;
		  } else { // promedio
			item.calificacion = sumatoria/item.evaluaciones.length;
		  }
	

		  if(isNaN(item.calificacion)){
			item.calificacion = 0;
		  }

		  this.obtenerCalificacionGeneral()


		}
	
	
	
		let body: any = {
		  id: this.form,
		  "parameter": subgrupo + '-'+ parameter,
		  "value": event.target.value
		}

		if(this.Admin){
			body._id = this.formid
		}
	

		console.log(body)
		this.api.updateEval(body).subscribe(
		  response => {
			console.log(response);
			this.toastr.success('Actualización correcta');
	
	
		  },
		  error => alert(error)
		);
	  }
	
	  // updateEval,
	  // getEval,
	
	
	  finalizarButton(event){

		if(this.numberCharactersLeft != 0 ){
			Swal.fire({
				title: 'Información faltante',
				text: 'Falta información en el comentario',
				icon: 'warning',
				showCancelButton: false,
				confirmButtonText: 'OK',

			  }).then((result) => {
				
			  });
	
			  return;

		}
	


		Swal.fire({
			title: 'Confirmación',
			text: '¿Está seguro que desea finalizar la evaluación?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'SI',
			cancelButtonText: 'NO'
		  }).then((result) => {
			if (result.isConfirmed) {


				let body : any = {
					id: this.form,
					"parameter": "evaluacionFinalizada",
					"value": true
				  }
				  if(this.Admin){
					body._id = this.formid
				}
	
				
				  console.log(body)
				  this.api.updateEval(body).subscribe(
					response => {
					  console.log(response);
					  this.toastr.success('Evaluacion Finalizada Correctamente');

					  setTimeout(()=>{
						this.navigateTo('/ventana2',{})
					  }, 1500)
			  
					},
					error => alert(error)
				  );


			} else if (result.dismiss === Swal.DismissReason.cancel) {

			}
		  });


	  }
	

	  obtenerCalificacionGeneral(guardar = true){
		console.log('obtenerCalificacionGeneral',this.formulario)

		this.calificacionTotal = 0;

		for(let i=0; i<this.formulario.formulario.length ; i++){

			let auxCalificacion = this.formulario.formulario[i].calificacion;

			if(!isNaN(auxCalificacion)){
				this.calificacionTotal = this.calificacionTotal + auxCalificacion;
			}
		}

		if (!guardar) {
			return;
		}

		let body: any = {
			id: this.form,
			"parameter": 'calificacionGeneral',
			"value": this.calificacionTotal
		  }

		  if(this.Admin){
			body._id = this.formid
		}
	

		  console.log(body)
		  this.api.updateEval(body).subscribe(
			response => {
			  console.log(response);
			//   this.toastr.success('Actualización correcta');
	  
	  
			},
			error => alert(error)
		  );
	  }
	
	
	  onInputKeyDown(event: KeyboardEvent): void {
		// Evita que se introduzcan caracteres manualmente
		event.preventDefault();
	  }
	
	
	  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	
	
	  abrirPostulacion(item){
		console.log(item)
		this.navigateTo('/ventana1', {form: item._id})
	  }
	
	
	  navigateTo(url: string, queryParams) {
		this.router.navigate([url], { queryParams: queryParams });
	  }
	
	
	
	  isOpen = false;
	
	  togglePanel() {
		this.isOpen = !this.isOpen;
	  }

	  countCharacters(event){

		this.numberCharactersLeft = (200 - event.target.value.length < 0)? 0: 200 - event.target.value.length

	  }



	}
